import gql from 'graphql-tag';

export const FRAGMENT_IPO_CALENDAR_PERIOD = gql`
  fragment calendarPeriod on IPOCalendarPeriod {
    periodFrom
    periodTo
  }
`;
